import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'
import { formatDate } from '@/utils/date'
import { IR_TOP_ROUTE } from '@/utils/routes'

import { Button } from '@/components/elements/Button'

export type MonthlySalesCardProps = {
  date: string
  yearPercent: string
}

const monthlySalesLink = IR_TOP_ROUTE.subdirectories[5].path

export const MonthlySalesCard = ({
  date,
  yearPercent,
}: MonthlySalesCardProps) => {
  return (
    <Card>
      <Title>
        <h2>月次売上高速報</h2>
        <span>{formatDate(date, 'yyyy年MM月')}度</span>
      </Title>
      <Explanation>既存店売上高（前年同月比）</Explanation>
      <Difference>
        <div>{Number(yearPercent).toFixed(1)}</div>
        <span>%</span>
      </Difference>
      <Link href={monthlySalesLink} passHref>
        <a>
          <LinkButton btnStyle="transparent">月次売上高速報</LinkButton>
        </a>
      </Link>
    </Card>
  )
}

const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 20px;
  gap: 10px;
  background: ${theme.colors.backgroundGrey};
  border-radius: 8px;
`

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 12px;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.grey};
  color: ${theme.colors.textTitle};
  text-align: center;
  height: 57px;

  @media screen and (max-width: 1047px) {
    height: 55px;
  }

  > h2 {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.2;

    @media screen and (max-width: 1047px) {
      font-size: 20px;
    }
  }

  > span {
    font-weight: 500;
    font-size: 12px;
    line-height: 1.6;
  }
`

const Explanation = styled.div`
  height: 28px;
  padding-top: 4px;
  padding-bottom: 10px
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.2;
  color: ${theme.colors.textSecond};
`

const Difference = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 10px;

  @media screen and (max-width: 1047px) {
    height: 40px;
  }

  > div {
    font-weight: 700;
    font-size: 30px;
    line-height: 1;
    color: ${theme.colors.trialBlue};
  }

  > span {
    font-weight: 500;
    font-size: 13px;
    line-height: 1.5;
  }
`

const LinkButton = styled(Button)`
  width: 200px;
  height: 42px;
  padding: 11px 26px 13px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  background-color: #ffffff;

  @media screen and (max-width: 1047px) {
    width: 295px;
    height: 42px;
  }
`
